(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gebo-audit-ui"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async event => {
    const action = event.target.closest('[data-gebo-withdrawal-action]');
    if (!action) return;
    if (action.dataset.geboWithdrawalAction === 'print') { window.print(); return; }
    const template = document.getElementById('gebo-withdrawal-template');
    const status = document.querySelector('[data-gebo-withdrawal-status]');
    if (!template || !status) return;
    try {
      await navigator.clipboard.writeText(template.innerText);
      status.textContent = status.dataset.success;
    } catch (_) {
      status.textContent = status.dataset.failure;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gebo-engraving"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gebo-engraving')) {
    customElements.define('gebo-engraving', class extends HTMLElement {
      connectedCallback() {
        const form = this.closest('form');
        const selection = form && form.querySelector('variant-selection');
        const field = this.querySelector('textarea');
        if (!selection || !field) return;
        const ids = this.dataset.variantIds.split(',');
        const update = () => {
          const active = ids.includes(selection.getAttribute('variant'));
          this.hidden = !active;
          field.disabled = !active;
        };
        this.observer = new MutationObserver(update);
        this.observer.observe(selection, { attributes: true, attributeFilter: ['variant'] });
        update();
      }
      disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gebo-gallery-privacy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async event => {
    const button = event.target.closest('[data-gebo-privacy]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-gebo-privacy-status]');
    button.disabled = true;
    status.hidden = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') {
        throw new Error('Privacy preferences unavailable');
      }
      await window.privacyBanner.showPreferences();
    } catch (_) {
      status.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gebo-storefront-enhancements"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-gebo-privacy]').forEach(button => {
    button.addEventListener('click', async () => {
      const status = button.parentElement.querySelector('[data-gebo-privacy-status]');
      try {
        if (!window.privacyBanner || !window.privacyBanner.showPreferences) throw new Error('unavailable');
        await window.privacyBanner.showPreferences();
        status.hidden = true;
      } catch (_) { status.hidden = false; }
    });
  });
  document.addEventListener('keydown', event => {
    const thumbnail = event.target.closest('.product-gallery__thumbnail[role="button"]');
    if (thumbnail && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      thumbnail.click();
    }
    if (event.key === 'Escape') {
      const toggle = document.querySelector('[data-show-mobile-menu="true"]');
      if (toggle) { toggle.click(); toggle.focus(); }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
